/*
 * @Author:lzy
 * @Date: 2020-07-07 14:23:47
 * @LastEditTime: 2020-09-23 14:43:10
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\directive\remarksReminder\remarksReminder.js
 * @Description: 备注强提示
 */
'use strict';
angular.module('remarksReminderModule', []).directive('remarksReminder', [
    function() {
        return {
            restrict: 'EA',
            repalace: true,
            scope: {
                remarks: '@',
                isHideClose: '=', // 是否显示关闭按钮
                textAlign: '@' // 文字对齐方式
            },
            templateUrl: './editingCenter/directive/remarksReminder/remarksReminder_tpl.html',
            link: function($scope, element) {
                $scope.close = function() {
                    $(element).remove();
                };
            }
        };
    }
]);
